import Vue from "vue";
import store from '../../store';
import omit from 'lodash/omit';

Vue.directive('authority', {
  inserted (el, binding, vnode) {
    let menuList = JSON.parse(localStorage.menuList);
    let crmMenuList = [];
    if (menuList) {
      crmMenuList = menuList.crm || [];
      menuList.sys = menuList.sys || [];
      crmMenuList = crmMenuList.concat(menuList.sys);
    }
    let flag = ~crmMenuList.indexOf(binding.value);
    if (!flag) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        el.innerHTML = '';
        el.style.display = 'none';
        // 解除组件的事件
        vnode.elm.__vue__ && vnode.elm.__vue__.$off();
        // 解除链接跳转
        el.tagName === 'A' && el.setAttribute('href', 'javascript:void(0)');
        // 解除元素点击事件
        if (vnode.data.on && vnode.data.on.click) {
          vnode.data.on.click.fn = () => {
            return;
          };
        };
        if (vnode.data.nativeOn && vnode.data.nativeOn.click) {
          vnode.data.nativeOn.click.fn = () => {
            return;
          };
        };
      }
    }
  }
});

Vue.directive('cancel', {
  bind: function (el, binding) {
    let pendingUrls = localStorage.getItem('pendingUrls');
    if (pendingUrls) {
      pendingUrls = JSON.parse(pendingUrls);
    } else {
      pendingUrls = {};
    }
    pendingUrls[binding.value.url] = false;
    localStorage.setItem('pendingUrls', JSON.stringify(pendingUrls));
  }
});

// 埋点指令
Vue.directive('lx', {
  bind: function (el, binding, vNode) {
    const handler = function (e) {
      const { value } = binding;
      if (!value || !value.bid) { return; }
      const valLab = {
        title: value.title,
        custom: {
          ...omit(value, ['bid', 'cid']),
          hotel_id: store.state.userInfo.hotelId || -1,
          agency_id: store.state.userInfo.agencyId || -1,
        }
      };
      const options = value.cid ? { cid: value.cid } : null;
      LXAnalytics && LXAnalytics('moduleClick', value.bid, valLab, options);
    };
    el.addEventListener('click', handler);
  }
});



// WEBPACK FOOTER //
// ./src/components/core/registerDirective.js